﻿import { LiveDataSetStation, LiveDataSetValue, Status } from "../API/LiveData/LiveDataSet";
import { DefaultParameterDefinitions } from "../DefaultParameterDefinitions";
import { MainSite } from "../MainSite";
import { Helideck } from "../Model/Helideck";
import { ParameterGroupInfo, ParameterGroupInfoSet } from "../ParameterGroupInfoSet";
import { IStationValueFormatter, IStationValueObject, WarningThreshold } from "./IStationValueFormatter";

export class HelideckStatusFormatter implements IStationValueFormatter {


    constructor(private helideck: Helideck) {

    }

    public getShortName(): string {
        return this.helideck.Label;
    }

    public getUnits(): string {
        return null;
    }

    public getParameterGroupInfo(): ParameterGroupInfo {
        return ParameterGroupInfoSet.Helideck_Status;
    }

    public getDescription(): string {
        return "Helideck status based on station-specific wind speed and direction rules.";
    }

    public getId(): string {
        return null;
    }

    public getSensorId(): string | undefined {
        return undefined;
    }

    public plottable(): boolean {
        return true;
    }

    public axisMin(): number {
        return null;
    }

    public axisMax(): number {
        return null;
    }

    public plotLines(): boolean {
        return true;
    }

    public format(liveDataSetStation: LiveDataSetStation): IStationValueObject {

        // the default if parameter has never existed
        var valueObject: IStationValueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Sensor: null,
            Timestamp: null
        }

        console.log(liveDataSetStation.GroupValues);
        if (ParameterGroupInfoSet.Helideck_Status.Id in liveDataSetStation.GroupValues) {

            const values = liveDataSetStation.GroupValues[ParameterGroupInfoSet.Helideck_Status.Id].filter(x => x.Sensor == this.helideck.Label);

            if (values.length != 1) {
                return valueObject;
            }

            var status: LiveDataSetValue = values[0];

            var paramDef = MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[liveDataSetStation.Station.Id]
                .Sensors[status.Sensor]
                .Parameters[status.Parameter]
                .Variants[0]
                .ParameterDefinition;
            if ((!paramDef || paramDef.Default) && status.Parameter in DefaultParameterDefinitions.Parameters) {
                paramDef = DefaultParameterDefinitions.Parameters[status.Parameter];
            }

            // the default if parameter exists but has expired
            valueObject = {
                Value: '///',
                Status: status.ExpiryStatus,
                WarningThreshold: null,
                ParameterDefinition: paramDef,
                Timestamp: status.Timestamp,
                Sensor: status.Sensor
            }

            if (typeof status.Value == 'number' && (status.ExpiryStatus == Status.Good || status.ExpiryStatus == Status.Expiring)) {

                switch (status.Value) {
                    case 1:
                        valueObject.Value = "Open";
                        valueObject.WarningThreshold = WarningThreshold.OK;
                        break;
                    case 2:
                        valueObject.Value = "Closed";
                        valueObject.WarningThreshold = WarningThreshold.Level3;
                        break;
                    default:
                        valueObject.Value = "Unknown";
                        valueObject.WarningThreshold = WarningThreshold.Level1;
                }
            }
        }

        return valueObject;
    }
}